/* ============================================================
   VIVĀRA — FAQ accordion
   ------------------------------------------------------------
   Progressive enhancement over plain markup: every answer is in the
   DOM and readable without JavaScript. Buttons carry aria-expanded,
   panels are height-animated at the shared motion speed, and the
   whole set is keyboard operable (Tab / Enter / Space, plus arrow
   keys and Home / End between questions).
   ============================================================ */
(function () {
  "use strict";

  var DURATION = 420; // matches the site's restrained transition speed

  function init() {
    document.querySelectorAll("[data-faq]").forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll("[data-faq-item]"));
      if (!items.length) return;

      var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      var entries = items.map(function (item) {
        var btn = item.querySelector("[data-faq-btn]");
        var panel = item.querySelector("[data-faq-panel]");
        return { item: item, btn: btn, panel: panel };
      }).filter(function (e) { return e.btn && e.panel; });

      function close(e) {
        e.btn.setAttribute("aria-expanded", "false");
        e.item.classList.remove("is-open");
        if (reduced) { e.panel.style.height = "0px"; return; }
        e.panel.style.height = e.panel.scrollHeight + "px";
        requestAnimationFrame(function () { e.panel.style.height = "0px"; });
      }

      function open(e) {
        e.btn.setAttribute("aria-expanded", "true");
        e.item.classList.add("is-open");
        if (reduced) { e.panel.style.height = "auto"; return; }
        e.panel.style.height = e.panel.scrollHeight + "px";
        window.setTimeout(function () {
          if (e.btn.getAttribute("aria-expanded") === "true") e.panel.style.height = "auto";
        }, DURATION);
      }

      entries.forEach(function (e, i) {
        // only the first question starts open
        var startOpen = i === 0;
        e.btn.setAttribute("aria-expanded", startOpen ? "true" : "false");
        e.item.classList.toggle("is-open", startOpen);
        e.panel.style.height = startOpen ? "auto" : "0px";

        e.btn.addEventListener("click", function () {
          var isOpen = e.btn.getAttribute("aria-expanded") === "true";
          entries.forEach(function (other) {
            if (other !== e && other.btn.getAttribute("aria-expanded") === "true") close(other);
          });
          if (isOpen) close(e); else open(e);
        });

        e.btn.addEventListener("keydown", function (ev) {
          var idx = entries.indexOf(e), target = null;
          if (ev.key === "ArrowDown") target = entries[(idx + 1) % entries.length];
          else if (ev.key === "ArrowUp") target = entries[(idx - 1 + entries.length) % entries.length];
          else if (ev.key === "Home") target = entries[0];
          else if (ev.key === "End") target = entries[entries.length - 1];
          if (target) { ev.preventDefault(); target.btn.focus(); }
        });
      });

      // keep an open panel correct if it reflows
      window.addEventListener("resize", function () {
        entries.forEach(function (e) {
          if (e.btn.getAttribute("aria-expanded") === "true") e.panel.style.height = "auto";
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
